import { useCallback } from 'react';

import useUser from 'src/hooks/use-user';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useModals, ModalNames } from 'components/modals';
import { useOrdersForConsumer } from 'src/components/embedded-account/content/order-list/use-orders-for-consumer/use-orders-for-consumer';
import { useReorder } from 'src/hooks/use-reorder';
import { ConsumerOrder } from 'src/components/embedded-account/account.types';

export type UseWidgetOrdersReturn = {
  orders: ConsumerOrder[];
  ordersLoading: boolean;
  reorder: ((order: ConsumerOrder) => Promise<void>) | undefined;
  loadingOrderId: string | null;
  handleViewOrder: (order: ConsumerOrder) => void;
};

export function useWidgetOrders(): UseWidgetOrdersReturn {
  const { dispensary } = useDispensary();
  const user = useUser();
  const { openModal } = useModals();
  const { reorder, loadingOrderId } = useReorder();
  const isEnabled = reorder !== undefined;
  const { orders, loading: rawOrdersLoading } = useOrdersForConsumer({ dispensary, skip: !isEnabled });
  const ordersLoading = isEnabled && rawOrdersLoading;

  const handleViewOrder = useCallback(
    (order: ConsumerOrder): void => {
      user.viewOrderId = order.orderId;
      void openModal(ModalNames.orderReceipt);
    },
    [user, openModal]
  );

  return {
    orders: orders as ConsumerOrder[],
    ordersLoading,
    reorder,
    loadingOrderId,
    handleViewOrder,
  };
}
